/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { magazineAction } from "@redux/modules";

import { NavLink } from 'react-router-dom';
import AccordionContext from 'react-bootstrap/AccordionContext';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Accordion from 'react-bootstrap/Accordion';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import PagePagination from "@components/PagePagination";

// Header - Footer
import Header from '../Layout/Header';
import Footer from '../Layout/Footer';

// Styles
import "./styles.scss";

const Tv = () => {
  const dispatch = useDispatch();
  
  const loginSettings = useSelector((store) => store.auth.loginSettings);
  const tvList = useSelector((store) => store.magazine.tvList);
  const tvCategoryList = useSelector(
    (store) => store.magazine.magazineCategoryList
  );

  const [selectedCategory, setSelectedCategory] = useState(0);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        await Promise.all([
          dispatch(magazineAction.getArticleList("TV", currentPage, pageSize)),
          dispatch(magazineAction.getArticleCategoryList("TV"))
        ]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
    return () => {};
  }, [dispatch, currentPage, pageSize]);

  useEffect(() => {
    if (tvList) {
      setTotalPages(tvList.totalPages);
    }
  }, [tvList]);

  const handleClickCategoryItem = (e, categoryId) => {
    setSelectedCategory(categoryId);
    setSelectedSubCategory(0);
    setCurrentPage(0);
    dispatch(magazineAction.getMagazineCategoryById("TV", categoryId, 0, pageSize));
  };

  const handleSubCategoryClick = (e, subCategoryId, subCategoryName) => {
    e.preventDefault();
    setSelectedSubCategory(subCategoryId);
    setCurrentPage(0);

    if (subCategoryId === 0) {
      dispatch(magazineAction.getArticleList("TV", 0, pageSize));
    } else {
      dispatch(magazineAction.getMagazineSubCategoryById("TV", subCategoryId, 0, pageSize));
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    if (selectedCategory) {
      dispatch(magazineAction.getMagazineCategoryById("TV", selectedCategory, page, pageSize));
    } else if (selectedSubCategory) {
      dispatch(magazineAction.getMagazineSubCategoryById("TV", selectedSubCategory, page, pageSize));
    } else {
      dispatch(magazineAction.getArticleList("TV", page, pageSize));
    }
  };

  const ContextAwareToggle = ({ children, eventKey, callback }) => {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(eventKey, () => {
      callback && callback(eventKey);
      
      if (currentEventKey === eventKey) {
        setActiveAccordion(null);
        dispatch(magazineAction.getArticleList("TV"));
      } else {
        setActiveAccordion(eventKey);
        handleClickCategoryItem(null, eventKey);
      }
    });

    const isCurrentEventKey = currentEventKey === eventKey;

    return (
      <button 
        type="button" 
        className={`btn btn-link ${selectedCategory === eventKey ? "text-green" : ""}`} 
        onClick={decoratedOnClick}
      >
        {children}{" "}
        {isCurrentEventKey ? (
          <span className="accordion-button-item active"></span>
        ) : (
          <span className="accordion-button-item"></span>
        )}
      </button>
    );
  };

  return (
    <div className="page-container">
      <Header />

      <main>
        <section className="bg-blue py-5 mb-sm-5 mb-3 d-lg-block d-none">
          <div className="container">
            <div className="d-lg-flex d-none text-white small mb-4 opacity-50">
              <NavLink
                to="/home"
                className="text-white text-decoration-none me-3"
              >
                Anasayfa
              </NavLink>
              <span className="me-3">»</span>
              <span>İçeriklerimiz</span>
            </div>
          </div>
        </section>

        <section className="mb-sm-10 mb-5 mt-lg-0 mt-sm-5 mt-3">
          <div className="container">
            <div className="row gy-0">
              <div className="col-xl-3 col-lg-4 order-1">
                <div className="ps-lg-5 ps-0">
                  <div className="offcanvas offcanvas-start offcanvas-responsive-lg">
                    <div className="offcanvas-header">
                      <h5 className="offcanvas-title">Kategoriler</h5>
                      <button
                        type="button"
                        className="btn-close text-reset"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                      ></button>
                    </div>
                    <div className="offcanvas-body">
                      <h4 className="mb-4 d-lg-block d-none">Kategoriler</h4>
                      {isLoading ? (
                        <div className="text-center py-4">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">
                              Yükleniyor...
                            </span>
                          </div>
                        </div>
                      ) : (
                        <Accordion activeKey={activeAccordion} className="pb-4">
                          <Card className="active">
                            <Card.Header>
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setSelectedCategory(0);
                                  setActiveAccordion(null);
                                  dispatch(magazineAction.getArticleList("TV"));
                                }}
                                className={
                                  selectedCategory === 0
                                    ? "btn btn-link text-decoration-none active"
                                    : "btn btn-link text-decoration-none"
                                }
                              >
                                Tüm İçerikler
                              </a>
                            </Card.Header>
                          </Card>

                          {tvCategoryList?.content?.length > 0 ? (
                            tvCategoryList.content
                              .filter((item) => item.active === true)
                              .map((item) => (
                                <Card key={item.id}>
                                  <Card.Header>
                                    <ContextAwareToggle eventKey={item.id}>
                                      {item.name}
                                    </ContextAwareToggle>
                                  </Card.Header>
                                  <Accordion.Collapse eventKey={item.id}>
                                    <Card.Body>
                                      {item.topicSubCategoryList?.length >
                                        0 && (
                                        <ul className="accordion-sub-menu">
                                          {item.topicSubCategoryList
                                            .filter(
                                              (subItem) =>
                                                subItem.active === true
                                            )
                                            .map((subItem) => (
                                              <li key={subItem.id}>
                                                <a
                                                  href="#"
                                                  onClick={(e) =>
                                                    handleSubCategoryClick(
                                                      e,
                                                      subItem.id,
                                                      subItem.name
                                                    )
                                                  }
                                                  className={
                                                    selectedSubCategory ===
                                                    subItem.id
                                                      ? "text-green"
                                                      : ""
                                                  }
                                                >
                                                  {subItem.name}
                                                </a>
                                              </li>
                                            ))}
                                        </ul>
                                      )}
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              ))
                          ) : (
                            <div className="text-center">
                              <p>Kategori bulunamadı</p>
                            </div>
                          )}
                        </Accordion>
                      )}
                    </div>
                  </div>
                  <a
                    href=".offcanvas"
                    className="btn btn-blue-light text-white rounded-circle p-0 d-flex align-items-center justify-content-center shadow position-fixed bottom-0 end-0 mb-3 me-3"
                    data-bs-toggle="offcanvas"
                  >
                    <i className="fas fa-list-alt"></i>
                  </a>
                </div>
              </div>
              <div className="col-xl-9 col-lg-8 order-0">
                {isLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Yükleniyor...</span>
                    </div>
                  </div>
                ) : tvList?.content?.length > 0 ? (
                  <>
                    {tvList.content.slice(0, 1).map((item) => (
                      <a
                        href={
                          item.videoArticleContent
                            ? item.videoArticleContent
                            : item.embededVideo
                        }
                        className="d-block overflow-hidden position-relative rounded-3 mb-sm-5 mb-3 mt-lg-n8 mt-0"
                        data-fancybox
                        key={item.id}
                      >
                        <div className="img-video bg-black">
                          {item.articleContentDTOList &&
                          item.articleContentDTOList.length > 0 &&
                          item.articleContentDTOList[0].baseAddress ? (
                            <img
                              src={item?.articleContentDTOList[0]?.baseAddress}
                              alt={item.name}
                              className="w-100 img-cover"
                              style={{ width: "960px", height: "480px" }}
                            />
                          ) : (
                            <div
                              style={{ height: "480px", background: "#000" }}
                            >
                              <img
                                src={loginSettings?.logo}
                                alt=""
                                className="w-100 opacity-50"
                                style={{
                                  width: "960px",
                                  height: "480px",
                                  objectFit: "scale-down",
                                }}
                              />
                            </div>
                          )}
                        </div>
                        <div className="position-absolute bottom-0 w-100 p-sm-5 p-4 overlay">
                          <span className="d-block small text-white mb-3">
                            {moment(item.dateCreated).format(
                              "DD.MM.YYYY - HH:mm"
                            )}{" "}
                            <span className="ms-3">
                              #{item.topicSubCategoryName}
                            </span>
                          </span>
                          <h2 className="mb-0 lh-base text-white">
                            {item.name}
                          </h2>
                        </div>
                      </a>
                    ))}

                    <div className="row g-sm-4 g-2">
                      {tvList.content.slice(1, 9999).map((item) => (
                        <div className="col-xl-4 col-6" key={item.id}>
                          <a
                            href={
                              item.videoArticleContent
                                ? item.videoArticleContent
                                : item.embededVideo
                            }
                            className="d-block bg-white text-decoration-none shadow rounded-3 overflow-hidden h-100"
                            data-fancybox
                          >
                            <div className="img-video bg-black">
                              {item.articleContentDTOList &&
                              item.articleContentDTOList.length > 0 &&
                              item.articleContentDTOList[0].baseAddress ? (
                                <img
                                  src={
                                    item?.articleContentDTOList[0]?.baseAddress
                                  }
                                  alt={item.name}
                                  className="w-100 img-cover"
                                  style={{ width: "300px", height: "200px" }}
                                />
                              ) : (
                                <div
                                  style={{
                                    height: "200px",
                                    background: "#000",
                                  }}
                                >
                                  <img
                                    src={loginSettings?.logo}
                                    alt=""
                                    className="w-100 opacity-50"
                                    style={{
                                      width: "300px",
                                      height: "200px",
                                      objectFit: "scale-down",
                                    }}
                                  />
                                </div>
                              )}
                            </div>
                            <div className="p-sm-4 p-3">
                              <span className="d-block text-blue small mb-1">
                                {moment(item.dateCreated).format(
                                  "DD.MM.YYYY - HH:mm"
                                )}
                              </span>
                              <h5 className="fw-normal lh-base mb-3">
                                {item.name}
                              </h5>
                              <div className="text-blue small">
                                <span className="me-2">
                                  #{item.topicSubCategoryName}
                                </span>
                              </div>
                            </div>
                          </a>
                        </div>
                      ))}
                    </div>

                    {/* Pagination */}
                    {tvList && tvList.totalElements > 0 && (
                      <div className="container">
                        <div className="pt-5">
                          <PagePagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={handlePageChange}
                          />
                        </div>
                      </div>
                    )}
                    {/* End Pagination */}
                  </>
                ) : (
                  <div className="text-center py-5">
                    <p>Seçili Kategoride içerik bulunamadı</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Tv;
